<div class="custom-folders-container"
     [ngClass]="{'compact-mode': compactMode}">
  <div *ngIf="!compactMode"
       class="search-container">
    <input #searchInput

           placeholder="Search for folder"
           type="text"

           [ngClass]="'search-input'"
           (input)="onSearchChange(searchInput.value)">
  </div>

  <mat-tree class="folder-tree"
            [dataSource]="dataSource"
            [ngClass]="{'compact-tree': compactMode}"
            [treeControl]="treeControl">

    <!-- This is the tree node template for leaf nodes -->
    <mat-tree-node *matTreeNodeDef="let node"
                   matTreeNodePadding>
      <button mat-flat-button
              [matTooltip]="node.name"
              [matTooltipPosition]="'above'"
              [matTooltipShowDelay]="500"
              [ngClass]="{
          'selected-folder': node.selected === true,
          'folder-boxed-button': true,
          'boxed-button-Custom': true
        }"
              [ngStyle]="{ 'margin-left': (node.level * 20) + 'px' }"
              (click)="selectFolderNode(node)">
        <mat-icon class="material-icons">
          folder
        </mat-icon>
        <span class="folder-name">
          {{node.name}}
        </span>
        <mat-icon *ngIf="node.selected"
                  [ngClass]="'check-icon'">
          check
        </mat-icon>
      </button>
    </mat-tree-node>

    <!-- This is the tree node template for expandable nodes -->
    <mat-tree-node *matTreeNodeDef="let node; when: hasChild"
                   matTreeNodePadding>
      <button class="expand-toggle-btn"

              mat-icon-button
              matTreeNodeToggle

              [attr.aria-label]="'Toggle ' + node.name"
              [ngStyle]="{ 'margin-left': (node.level * 20) + 'px' }">
        <mat-icon class="expand-collapse-icon mat-icon-rtl-mirror">
          {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
        </mat-icon>
      </button>
      <button mat-flat-button
              [matTooltip]="node.name"
              [matTooltipPosition]="'above'"
              [matTooltipShowDelay]="500"
              [ngClass]="{
          'selected-folder': node.selected === true,
          'folder-boxed-button': true,
          'boxed-button-Custom': true
        }"
              (click)="selectFolderNode(node)">
        <mat-icon class="material-icons">
          folder
        </mat-icon>
        <span class="folder-name">
          {{node.name}}
        </span>
        <mat-icon *ngIf="node.selected"
                  [ngClass]="'check-icon'">
          check
        </mat-icon>
      </button>
    </mat-tree-node>
  </mat-tree>

  <div *ngIf="!compactMode"
       class="create-folder-row">
    <input #foldername

           id="foldernameValue"
           placeholder="Create a folder"
           type="text"

           [ngClass]="'input-text'"
           (keyup)="handleCreateFolder(foldername.value, false, customFoldersColor, $event)">
    <button [ngClass]="'arrow-button'"
            (click)="handleCreateFolder(foldername.value, false, customFoldersColor, $event); foldername.value = ''">
      <mat-icon>
        keyboard_arrow_right
      </mat-icon>
    </button>
    <span *ngIf="validation.value"
          [ngClass]="['mat-body', 'message-box']">
      {{validation.text(foldername.value)}}
    </span>
  </div>
</div>
